import { useState } from 'react';
import { AdminHeaderButtonView } from '@vivli/shared/views';
import { useDataRequestsApiContext, useModalApiContext } from '@vivli/core/infrastructure/context';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { downloadFile } from '@vivli/shared/infrastructure/hook';
import { finalize, first } from 'rxjs/operators';

export const AmrPrintButtonView = () => {
    const modalService = useModalApiContext();
    const { dataRequest } = useDataRequestContext();
    const [isLoading, setIsLoading] = useState(false);
    const api = useDataRequestsApiContext();

    const handleError = (error) => {
        modalService.error(error);
    };

    const handlePrintClick = () => {
        setIsLoading(true);
        const dataRequestId = dataRequest.dataRequestDoi ? dataRequest.dataRequestDoi : dataRequest.id;
        api.downloadDataRequestPdf(dataRequest.id, false)
            .pipe(
                first(),
                finalize(() => setIsLoading(false))
            )
            .subscribe((data) => {
                downloadFile(
                    'data:application/pdf;base64,' + data,
                    `DataRequest-${dataRequestId}-${new Date().toDateString().replace(/ /g, '_')}.pdf`
                );
            }, handleError);
    };

    return <AdminHeaderButtonView title={'Download PDF'} style={{ marginLeft: 10 }} onClick={handlePrintClick} isLoading={isLoading} />;
};
